import { FilterService } from '../../service/filter/filter.service';
import { Component, ChangeDetectorRef, Input, EventEmitter, OnDestroy, Output, AfterViewInit, OnInit } from '@angular/core';
import { SubSink } from "subsink";
import { FavoriteService } from 'src/app/air/modules/common/service/favorite/favorite.service';
import { DialogService } from 'src/app/air/modules/common/service/dialog/dialog.service';
import { ShipmentService } from '../../service';
@Component({
    selector: 'bdp-pin-to-widget',
    templateUrl: './pin-to-widget.component.html',
    styleUrls: ['./pin-to-widget.component.scss'],
    standalone: false
})
export class PingToWidget implements OnInit, OnDestroy {

  @Input() shipment: any;
  @Input() settings: any = { hideTooltip: false };
  private subscription = new SubSink();
  tooltip!: string;
  keyRef: any = {};
  keyRefRespectiveValue!: string;
  pinnedItemsCount!: number;
  isPinnedItemRestrictionReached!: boolean;
  constructor(
    private ref: ChangeDetectorRef,
    private dialogService: DialogService,
    private favoriteService: FavoriteService,
    private filterService: FilterService,
    private shipmentService: ShipmentService) {
  }

  ngOnInit() {
    // this.changeTooltip();
    this.subscription.add(
      this.filterService.$keyRef.subscribe((keyRef) => {
        keyRef = JSON.parse(JSON.stringify(keyRef));
        if (this.shipment[keyRef.key] && this.shipment[keyRef.key].toLowerCase() != "n/a") {
          keyRef.value = this.shipment[keyRef.key];
        } else {
          keyRef = {
            key: 'bdpRefno',
            label: 'Forwarder Ref No. ',
            value: this.shipment.bdpRefno,
            shortLabel: 'Forwarder Ref No. ',
            keyIndex: 1
          }
        }
        this.keyRef = keyRef;
      }),
      this.shipmentService.$pinnedShipment.subscribe(count => {
        this.pinnedItemsCount = count;
      })
    );
  }

  changeTooltip() {
    if (this.settings.hideTooltip) {
      this.tooltip = '';
    } else {
      if (this.shipment.pin) {
        this.tooltip = 'Click to Pin/Unpin. A maximum of 15 pinned favorites is allowed.';
      } else {
        this.tooltip = 'Click to Pin/Unpin. A maximum of 15 pinned favorites is allowed.';
      }
    }
    this.ref.detectChanges();
  }

  updateToWidget() {
  //  console.log(this.shipment);
    const data = this.dialogService.getToasterData();
    if (this.shipment) {
      // this.changeTooltip();
      if (this.shipment.pin) {
        this.removeFromWidget();
        // const data = this.dialogService.getConfirmData();
        // data.buttons.accept.action = () => {
        // }
        // data.isOpen = true;
        // data.header = 'Are you sure, that you want to remove from Favorites ?';
        // this.dialogService.updateDialogData(data);
      } else {
        if (this.pinnedItemsCount < 15)
          this.addToWidget();
        else {
          this.isPinnedItemRestrictionReached = true
          data.content = `A maximum of 15 pinned shipment is allowed.`;
          data.severity = 'error';
          data.hasUndo = false
          this.dialogService.updateToasterData(data);
        }
      }
    }
  }
  private setKeyRefValue(keyRef: { label: string; key: string | number; }) {
    this.keyRefRespectiveValue = keyRef.label + " " + this.shipment[keyRef.key];
  }

  private addToWidget() {
    this.setKeyRefValue(this.keyRef);
    const data = this.dialogService.getToasterData();
    this.subscription.add(
      this.favoriteService.pinToFavoriteWidget({
        "shipmentId": this.shipment.shipmentId,
        "isPinned": true,
      }).subscribe((response: any) => {
        this.shipment.pin = !this.shipment.pin;
        data.content = `Shipment ${this.keyRefRespectiveValue} successfully pinned to favorites widget`;
        this.dialogService.updateToasterData(data);
        this.shipmentService.updatePinnedShipmentCount(this.pinnedItemsCount + 1)
      }, (error) => {
        data.content = 'Unable to add shipment to favorites widget';
        data.severity = 'error';
        data.hasUndo = false
        this.dialogService.updateToasterData(data);
      }));
  }


  private removeFromWidget() {
    this.setKeyRefValue(this.keyRef);
    const data = this.dialogService.getToasterData(false);
    data.hasUndo = true;
    this.subscription.add(
      this.favoriteService.pinToFavoriteWidget({
        "shipmentId": this.shipment.shipmentId,
        "isPinned": false,
      }).subscribe((response: any) => {
        /* update other componet to remove shipment from favorites*/
        this.shipment.pin = !this.shipment.pin;
        /* update toaster message*/
        data.undo.action = () => {
          this.addToWidget();
        };
        data.content = `Shipment ${this.keyRefRespectiveValue} successfully removed from favorite widget`;
        this.dialogService.updateToasterData(data);
        this.shipmentService.updatePinnedShipmentCount(this.pinnedItemsCount - 1)
      }, (error) => {
        data.content = 'Unable to remove shipment from favorite widget';
        data.severity = 'error';
        data.hasUndo = false
        this.dialogService.updateToasterData(data);
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
